export default "__VITE_ASSET__ba5ac8b8__"